export default __webpack_public_path__ + "static/media/error_frame.c388e092.png";